module.exports = __webpack_public_path__ + "static/media/advantages1.81021b5a.png";